import { render, staticRenderFns } from "./OrderDuplicateDialog.vue?vue&type=template&id=b72978cc&"
import script from "./OrderDuplicateDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderDuplicateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports